import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { FilterRowWithCheckbox } from "~/components/Filters/FilterRowWithCheckbox";
import { TYPE_FILTERS } from "~/components/Filters/types";
import { useTemporaryFeatureFlags } from "~/hooks/useTemporaryFeatureFlags";
export const defaultTypes = [
    "boards",
    "files",
    "assets"
];
const typeFiltersLabels = {
    assets: "Assets",
    files: "Files",
    boards: "Boards"
};
export const TypeFilter = /*#__PURE__*/ memo((param)=>{
    let { availableTypes = defaultTypes, selectedTypes, selectedAssetFileKinds, onTypeSelectedChange, onAssetFileKindSelectedChange } = param;
    const { searchImprovements } = useTemporaryFeatureFlags();
    const filteredTypes = useMemo(()=>{
        return Object.values(TYPE_FILTERS).filter((typeFilter)=>availableTypes.includes(typeFilter.id));
    }, [
        availableTypes
    ]);
    if (searchImprovements) {
        return /*#__PURE__*/ _jsx("div", {
            children: filteredTypes.map((typeFilter)=>{
                const isSelected = selectedTypes.includes(typeFilter.id);
                const isPartialSelected = typeFilter.subFilters && Object.values(typeFilter.subFilters).some((subFilter)=>selectedAssetFileKinds.includes(subFilter.id));
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx(FilterRowWithCheckbox, {
                            icon: typeFilter.icon,
                            label: typeFilter.label,
                            isSelected: isPartialSelected || isSelected,
                            isPartialSelected: isPartialSelected,
                            onChange: (isSelected)=>onTypeSelectedChange({
                                    type: typeFilter.id,
                                    isSelected
                                })
                        }),
                        typeFilter.subFilters && /*#__PURE__*/ _jsx("div", {
                            className: "pl-6",
                            children: Object.values(typeFilter.subFilters).map((subFilter)=>{
                                return /*#__PURE__*/ _jsx(FilterRowWithCheckbox, {
                                    icon: subFilter.icon,
                                    label: subFilter.label,
                                    isSelected: selectedAssetFileKinds.includes(subFilter.id) || isSelected,
                                    onChange: (isSelected)=>onAssetFileKindSelectedChange({
                                            assetFileKind: subFilter.id,
                                            isSelected,
                                            type: typeFilter.id
                                        })
                                }, subFilter.id);
                            })
                        })
                    ]
                }, typeFilter.id);
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        children: availableTypes.map((type)=>/*#__PURE__*/ _jsx(FilterRowWithCheckbox, {
                label: typeFiltersLabels[type],
                isSelected: selectedTypes.includes(type),
                onChange: (isSelected)=>onTypeSelectedChange({
                        type,
                        isSelected
                    })
            }, type))
    });
});
TypeFilter.displayName = "TypeFilter";
